<script setup>
defineProps({
  width: {
    type: Number,
    default: 18,
  },
  height: {
    type: Number,
    default: 21,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.624 5.11335L12.7207 2.20835C12.1801 1.66513 11.5372 1.23446 10.8292 0.941235C10.1212 0.648009 9.36202 0.498047 8.59567 0.500019H4.83317C3.72851 0.501342 2.66947 0.940754 1.88835 1.72187C1.10724 2.50298 0.667827 3.56202 0.666504 4.66669V16.3334C0.667827 17.438 1.10724 18.4971 1.88835 19.2782C2.66947 20.0593 3.72851 20.4987 4.83317 20.5H13.1665C14.2712 20.4987 15.3302 20.0593 16.1113 19.2782C16.8924 18.4971 17.3318 17.438 17.3332 16.3334V9.23752C17.3352 8.4712 17.1852 7.7121 16.8919 7.00416C16.5985 6.29623 16.1675 5.65355 15.624 5.11335ZM14.4457 6.29169C14.7001 6.55347 14.919 6.84768 15.0965 7.16669H11.4998C11.2788 7.16669 11.0669 7.07889 10.9106 6.92261C10.7543 6.76633 10.6665 6.55437 10.6665 6.33335V2.73669C10.9856 2.91412 11.2801 3.13265 11.5423 3.38669L14.4457 6.29169ZM15.6665 16.3334C15.6665 16.9964 15.4031 17.6323 14.9343 18.1011C14.4654 18.57 13.8295 18.8334 13.1665 18.8334H4.83317C4.17013 18.8334 3.53424 18.57 3.0654 18.1011C2.59656 17.6323 2.33317 16.9964 2.33317 16.3334V4.66669C2.33317 4.00364 2.59656 3.36776 3.0654 2.89892C3.53424 2.43008 4.17013 2.16669 4.83317 2.16669H8.59567C8.73234 2.16669 8.86484 2.19335 8.99984 2.20585V6.33335C8.99984 6.99639 9.26323 7.63228 9.73207 8.10112C10.2009 8.56996 10.8368 8.83335 11.4998 8.83335H15.6273C15.6398 8.96835 15.6665 9.10002 15.6665 9.23752V16.3334Z"
      fill="#8C8C8C"
    />
  </svg>
</template>
